<div *ngFor="let group of questionsAnswersForm.controls; let i = index">
  <div [formGroup]="group">
    <div class="form-row">
      <div class="col form-group">
        <label class="required" for="question_{{i+1}}">{{ strings.question }} {{i+1}}</label>
        <ti-input-validation-wrap [firstSubmit]="firstSubmit" [config]="{inputWithSecondIcon: true}" [control]="group.get(QUESTION_FIELD)">
          <kendo-dropdownlist
            tiKendoDropDownTooltip
            class="form-control"
            id="question_{{i+1}}"
            [formControlName]="QUESTION_FIELD"
            [data]="questionsListFiltered$ | async"
            [textField]="'question'"
            [valueField]="'questionId'"
            [valuePrimitive]="true"
          ></kendo-dropdownlist>
        </ti-input-validation-wrap>
      </div>
    </div>
    <div class="form-row">
      <div class="col form-group">
        <label class="required" for="answer_{{i+1}}">{{ strings.answer }} {{i+1}}</label>
        <ti-input-validation-wrap [firstSubmit]="firstSubmit" [control]="group.get(ANSWER_FIELD)" [config]="answersMasked ? {inputWithSecondIcon: true} : {}">
          <ti-field-eye [hideMask]="!answersMasked" [outerManage]="true" (onMasked)="toggleAllMasks($event, i)">
            <input class="form-control" id="answer_{{i+1}}" [formControlName]="ANSWER_FIELD" [title]="miscStrings.answer" />
          </ti-field-eye>
        </ti-input-validation-wrap>
      </div>
    </div>
  </div>
</div>

<ti-provide-password
  *ngIf="showProvidePassword"
  (confirmPassword)="confirmPassword($event)"
  (close)="showProvidePassword = false"
></ti-provide-password>
